/* MAVE – motion layer: scroll reveal, hero parallax, product showcase, scrolling text, shop-by-mood */
(function () {
  var root = document.documentElement;
  root.classList.add('mave-js');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var hasIO = 'IntersectionObserver' in window;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- 1. Scroll reveal ---------- */
  var revealIO = null;
  function reveal(scope) {
    var items = (scope || document).querySelectorAll('.mave-reveal:not(.is-in)');
    if (reduce || !hasIO) { each(items, function (el) { el.classList.add('is-in'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    each(items, function (el) { revealIO.observe(el); });
  }

  /* ---------- 2. Hero parallax ---------- */
  var parallaxOn = false;
  function parallax() {
    if (reduce || parallaxOn) return;
    var media = document.querySelectorAll('[data-mave-parallax]');
    if (!media.length) return;
    parallaxOn = true;
    var ticking = false;
    function update() {
      var y = window.scrollY || window.pageYOffset;
      each(document.querySelectorAll('[data-mave-parallax]'), function (m) {
        var h = m.offsetHeight || 1;
        if (y < h * 1.2) m.style.transform = 'translate3d(0,' + (y * 0.18).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ---------- 3. Product cards: hover image + colour swatches ---------- */
  function initCards(scope) {
    each(scope.querySelectorAll('.mave-card'), function (card) {
      if (card.__mave) return; card.__mave = true;
      var alt = card.querySelector('.mave-card__img--alt');
      var link = card.querySelector('.mave-card__link');
      var baseUrl = link ? link.getAttribute('href') : null;
      var sws = card.querySelectorAll('.mave-sw');
      var picked = null;

      function setAlt(sw) {
        if (!alt) return;
        var src = sw ? sw.getAttribute('data-src') : alt.getAttribute('data-src');
        var set = sw ? sw.getAttribute('data-srcset') : alt.getAttribute('data-srcset');
        if (set && alt.getAttribute('srcset') !== set) { alt.setAttribute('srcset', set); alt.setAttribute('src', src); }
      }
      function show(sw) {
        if (!sw || sw.hasAttribute('data-main') || !alt) { card.classList.remove('show-alt'); return; }
        setAlt(sw);
        card.classList.add('show-alt');
      }
      function pick(sw) {
        picked = sw;
        each(sws, function (s) { s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
        if (link) link.setAttribute('href', sw.getAttribute('data-url') || baseUrl);
        show(sw);
      }
      each(sws, function (sw) {
        sw.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); pick(sw); });
        if (canHover) sw.addEventListener('mouseenter', function () { show(sw); });
      });
      if (canHover && alt) {
        card.addEventListener('mouseenter', function () {
          if (picked) return;
          setAlt(null);
          card.classList.add('show-alt');
        });
        card.addEventListener('mouseleave', function () {
          if (picked) show(picked); else card.classList.remove('show-alt');
        });
      }
    });
  }

  /* ---------- 4. Product showcase (tabs + rail) ---------- */
  function initShowcase(sec) {
    if (sec.__mave) return; sec.__mave = true;
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(sec.querySelectorAll('[role="tabpanel"]'));
    if (!panels.length) return;
    var ink = sec.querySelector('.mave-show__ink');
    var thumb = sec.querySelector('.mave-show__progress span');
    var viewAll = sec.querySelector('[data-mave-viewall]');
    var prev = sec.querySelector('.mave-show__arrow[data-dir="-1"]');
    var next = sec.querySelector('.mave-show__arrow[data-dir="1"]');
    var current = 0;
    var seen = false;

    function rail() { return panels[current].querySelector('.mave-show__rail'); }
    function cardsOf(panel) { return panel.querySelectorAll('.mave-stagger'); }

    function moveInk() {
      var t = tabs[current];
      if (!ink || !t) return;
      ink.style.width = t.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + t.offsetLeft + 'px)';
    }
    function progress() {
      var r = rail();
      if (!r) return;
      var max = r.scrollWidth - r.clientWidth;
      var ratio = r.scrollWidth ? Math.min(1, r.clientWidth / r.scrollWidth) : 1;
      var p = max > 0 ? r.scrollLeft / max : 0;
      if (thumb) {
        thumb.style.width = (ratio * 100).toFixed(2) + '%';
        thumb.style.transform = 'translateX(' + (ratio > 0 ? (p * (1 - ratio) / ratio * 100) : 0).toFixed(2) + '%)';
      }
      if (prev) prev.disabled = r.scrollLeft <= 4;
      if (next) next.disabled = r.scrollLeft >= max - 4;
    }
    function enter(panel) {
      each(cardsOf(panel), function (c) { c.classList.add('is-in'); });
    }
    function select(i, focus) {
      if (i === current || !panels[i]) return;
      if (tabs[current]) { tabs[current].setAttribute('aria-selected', 'false'); tabs[current].tabIndex = -1; }
      panels[current].hidden = true;
      current = i;
      if (tabs[i]) { tabs[i].setAttribute('aria-selected', 'true'); tabs[i].tabIndex = 0; if (focus) tabs[i].focus(); }
      // Reset the cards while the panel is still hidden so they animate in again
      if (!reduce) each(cardsOf(panels[i]), function (c) { c.classList.remove('is-in'); });
      panels[i].hidden = false;
      var r = rail(); if (r) r.scrollLeft = 0;
      void panels[i].offsetWidth;
      enter(panels[i]);
      if (viewAll) {
        viewAll.setAttribute('href', panels[i].getAttribute('data-url'));
        viewAll.textContent = panels[i].getAttribute('data-label');
      }
      moveInk();
      progress();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });

    panels.forEach(function (p) {
      var r = p.querySelector('.mave-show__rail');
      if (!r) return;
      var queued = false;
      r.addEventListener('scroll', function () {
        if (queued) return; queued = true;
        window.requestAnimationFrame(function () { queued = false; progress(); });
      }, { passive: true });
    });

    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var r = rail(); if (!r) return;
        var card = r.querySelector('.mave-card');
        var gap = parseFloat(window.getComputedStyle(r).columnGap) || 0;
        var step = card ? card.getBoundingClientRect().width + gap : r.clientWidth * 0.8;
        var per = Math.max(1, Math.floor((r.clientWidth + gap) / step) - 1);
        r.scrollBy({ left: Number(b.getAttribute('data-dir')) * step * per, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    // Cards appear together (staggered) when the section first comes into view
    if (hasIO && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !seen) { seen = true; enter(panels[current]); io.disconnect(); }
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
      io.observe(sec);
    } else {
      each(sec.querySelectorAll('.mave-stagger'), function (c) { c.classList.add('is-in'); });
    }

    sec.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target);
      if (i > -1) select(i);
    });

    window.addEventListener('resize', function () { moveInk(); progress(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveInk(); progress(); });
    moveInk();
    progress();
    initCards(sec);
  }

  /* ---------- 5. Scrolling text: speeds up with scroll ---------- */
  function initMarquee(el) {
    if (el.__mave) return; el.__mave = true;
    if (reduce) return;
    var track = el.querySelector('.mave-marquee__track');
    if (!track || !track.getAnimations) return;
    var anim = null, lastY = window.scrollY || 0, rate = 1, boost = 1, raf = null, visible = false;
    if (hasIO) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(el);
    else visible = true;
    function getAnim() {
      if (!anim) { var a = track.getAnimations(); anim = a && a.length ? a[0] : null; }
      return anim;
    }
    function tick() {
      var a = getAnim();
      boost += (1 - boost) * 0.04;
      rate += (boost - rate) * 0.12;
      if (a) a.playbackRate = rate;
      if (Math.abs(rate - 1) > 0.005 || Math.abs(boost - 1) > 0.005) raf = window.requestAnimationFrame(tick);
      else { if (a) a.playbackRate = 1; rate = boost = 1; raf = null; }
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY || 0, d = Math.abs(y - lastY);
      lastY = y;
      if (!visible) return;
      boost = Math.max(boost, Math.min(4.5, 1 + d / 10));
      if (!raf) raf = window.requestAnimationFrame(tick);
    }, { passive: true });
  }

  /* ---------- 6. Shop by mood ---------- */
  function initMoods(sec) {
    if (sec.__mave) return; sec.__mave = true;
    var rows = Array.prototype.slice.call(sec.querySelectorAll('.mave-moods__row'));
    var sets = Array.prototype.slice.call(sec.querySelectorAll('.mave-moods__set'));
    var stage = sec.querySelector('.mave-moods__stage');
    var list = sec.querySelector('.mave-moods__list');
    var toggle = sec.querySelector('.mave-moods__toggle');
    if (!rows.length || rows.length !== sets.length) return;
    var current = 0, inView = false, userPaused = reduce, hoverPaused = false;

    function setPaused() {
      sec.classList.toggle('is-paused', userPaused || hoverPaused || !inView || rows.length < 2);
      if (toggle) {
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        toggle.setAttribute('aria-label', toggle.getAttribute(userPaused ? 'data-play' : 'data-pause'));
      }
    }
    function restartBar(i) {
      var bar = rows[i].querySelector('.mave-moods__bar i');
      if (!bar) return;
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
    }
    function go(i) {
      if (i === current || !sets[i]) return;
      var old = sets[current];
      old.classList.remove('is-active');
      old.classList.add('is-leaving');
      old.inert = true;
      clearTimeout(old.__t);
      old.__t = setTimeout(function () { old.classList.remove('is-leaving'); }, 800);
      rows[current].classList.remove('is-active');
      current = i;
      clearTimeout(sets[i].__t);
      sets[i].classList.remove('is-leaving');
      sets[i].classList.add('is-active');
      sets[i].inert = false;
      rows[i].classList.add('is-active');
      var tint = rows[i].getAttribute('data-tint');
      if (tint) sec.style.setProperty('--tint', tint);
      restartBar(i);
    }

    rows.forEach(function (r, i) {
      var bar = r.querySelector('.mave-moods__bar i');
      if (bar) bar.addEventListener('animationend', function () {
        if (i === current) go((current + 1) % rows.length);
      });
      if (canHover) r.addEventListener('mouseenter', function () { go(i); });
      r.addEventListener('focus', function () { go(i); });
    });

    [list, stage].forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseenter', function () { hoverPaused = true; setPaused(); });
      el.addEventListener('mouseleave', function () { hoverPaused = false; setPaused(); });
      el.addEventListener('focusin', function () { hoverPaused = true; setPaused(); });
      el.addEventListener('focusout', function () { hoverPaused = false; setPaused(); });
    });

    if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; setPaused(); });

    // Swipe between collections on touch screens
    if (stage) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = y0 = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) go((current + (dx < 0 ? 1 : -1) + rows.length) % rows.length);
      }, { passive: true });
    }

    // Gentle depth on mouse move
    if (stage && canHover && !reduce) {
      var mxq = false, lastE = null;
      stage.addEventListener('mousemove', function (e) {
        lastE = e;
        if (mxq) return; mxq = true;
        window.requestAnimationFrame(function () {
          mxq = false;
          var b = stage.getBoundingClientRect();
          stage.style.setProperty('--mx', ((lastE.clientX - b.left) / b.width * 2 - 1).toFixed(3));
          stage.style.setProperty('--my', ((lastE.clientY - b.top) / b.height * 2 - 1).toFixed(3));
        });
      });
      stage.addEventListener('mouseleave', function () { stage.style.setProperty('--mx', 0); stage.style.setProperty('--my', 0); });
    }

    if (hasIO) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView && !sec.classList.contains('is-seen')) { sec.classList.add('is-seen'); restartBar(current); }
        setPaused();
      }, { rootMargin: '-20% 0px -20% 0px', threshold: 0 }).observe(sec);
    } else {
      inView = true;
      sec.classList.add('is-seen');
    }

    sec.addEventListener('shopify:block:select', function (e) {
      var li = e.target.closest ? e.target.closest('li') : null;
      var row = li ? li.querySelector('.mave-moods__row') : null;
      var i = rows.indexOf(row);
      if (i > -1) { userPaused = true; go(i); setPaused(); }
    });

    setPaused();
  }

  /* ---------- Boot ---------- */
  function initAll(scope) {
    scope = scope || document;
    reveal(scope);
    each(scope.querySelectorAll('[data-mave-show]'), initShowcase);
    each(scope.querySelectorAll('[data-mave-marquee]'), initMarquee);
    each(scope.querySelectorAll('[data-mave-moods]'), initMoods);
  }
  function init() { initAll(document); parallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
